import React from 'react';
import {
  Box, Grid, Skeleton, useTheme, useMediaQuery,
} from '@mui/material';
import { IconicRideCardSkeleton } from 'views/rebranded-module/common/components';

const ToursSectionSkeleton = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const getnumber = () => {
    let n;
    if (isTablet && !isMobile) {
      n = 2;
    } else if (isTablet && isMobile) {
      n = 1;
    } else {
      n = 3;
    }
    return n;
  };

  return (
    <Box>
      <Skeleton variant="rectangular" width="200px" height={40} />
      <Box my={3}>
        <Grid container spacing={2}>
          {[...Array(getnumber()).keys()].map((item) => (
            <Grid item xs={12} md={6} lg={4} key={item}>
              <IconicRideCardSkeleton />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
export { ToursSectionSkeleton };
